export function watermeter(ctx, node) {
    return function(ctx, node) {
        const i = node.rect.width
          , n = node.rect.height
          , r = i > n ? i : n
          , o = i > n ? n - 4 : i - 4;
        let s;
        s = i >= n ? o : r;
        const a = .2
          , c = 1
          , l = Math.floor(10 * Math.random())
          , h = node.value / 100 * o;
        let u = 0
          , d = 0
          , f = 0
          , p = Math.abs(h - o / 2);
        h / (o / 2) >= 1 ? (u = node.rect.x + i / 2 - Math.sqrt(o / 2 * (o / 2) - p * p),
        node.rect.y,
        d = node.rect.x + i / 2 + Math.sqrt(o / 2 * (o / 2) - p * p),
        f = Math.asin(p / (o / 2))) : (u = node.rect.x + i / 2 - Math.sqrt(o / 2 * (o / 2) - p * p),
        node.rect.y,
        d = node.rect.x + i / 2 + Math.sqrt(o / 2 * (o / 2) - p * p),
        f = -Math.asin(p / (o / 2)));
        ctx.beginPath(),
        ctx.fillStyle = node.fillStyle,
        node.value > getDataValue(node.data,"max") && (ctx.fillStyle = getDataValue(node.data,"maxBackground")|| "#f5222d");
        node.value < getDataValue(node.data,"min") && (ctx.fillStyle = getDataValue(node.data,"minBackground")|| "#52c41a");
        ctx.arc(node.rect.x + i / 2, node.rect.y + n / 2, o / 2, -f, Math.PI + f);
        for (let v = u; v < d; v += 20 / (d - u)) {
            const i = c * Math.sin((u + v) * a + l) + node.rect.y + o / 2 - h;
            ctx.lineTo(v, s / 2 + i)
        }
        ctx.stroke(),
        ctx.fill(),
        ctx.closePath()
    }(ctx, node),
    getDataValue(node.data,"scaleShow")&& function(ctx, node) {
        const i = node.rect.x
          , n = node.rect.y
          , r = node.rect.width
          , o = node.rect.height
          , s = r > o ? r : o
          , a = r > o ? o : r
          , c = Math.floor(a / 2)
          , l = 7
          , h = a
          , u = getDataValue(node.data,"max")
          , d = getDataValue(node.data,"min");
        let f, p, v, g, y, m, w = 0;
        /*getDataValue(node.data,"maxText") || (getDataValue(node.data,"maxText")  = "max");
        getDataValue(node.data,"minText") || (getDataValue(node.data,"minText") = "min");*/
        d && (r > o ? (f = Math.abs(n + (100 - d) / 100 * h - (n + h / 2)),
        p = Math.sqrt(Math.pow(c, 2) - Math.pow(f, 2)),
        v = c - p + i + s / 2 - a / 2) : (f = Math.abs(n + (100 - d) / 100 * h - (n + h / 2)),
        p = Math.sqrt(Math.pow(c, 2) - Math.pow(f, 2)),
        v = c - p + i));
        u && (r > o ? (g = Math.abs(n + (100 - u) / 100 * h - (n + h / 2)),
        y = Math.sqrt(Math.pow(c, 2) - Math.pow(g, 2)),
        m = c - y + i + s / 2 - a / 2) : (g = Math.abs(n + (100 - u) / 100 * h - (n + h / 2)),
        y = Math.sqrt(Math.pow(c, 2) - Math.pow(g, 2)),
        m = c - y + i));
        ctx.beginPath(),
        ctx.fillStyle = "#000";
        let b = a / 10;
        ctx.font = b + "px Arial",
        d && u ? v > m ? (w = v - m,
        r >= o ? (ctx.moveTo(v, n + (100 - d) / 100 * h),
        ctx.lineTo(v - l - w, n + (100 - d) / 100 * h),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"minText"), v - l - w, n + (100 - d) / 100 * h + 3),
        ctx.fillText(d, v - l - w, n + (100 - d) / 100 * h + b),
        ctx.moveTo(m, n + (100 - u) / 100 * h),
        ctx.lineTo(m - l, n + (100 - u) / 100 * h),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"maxText") , m - l, n + (100 - u) / 100 * h + 3),
        ctx.fillText(u, m - l, n + (100 - u) / 100 * h + b)) : (ctx.moveTo(v, n + (100 - d) / 100 * h + s / 2 - a / 2),
        ctx.lineTo(v - l - w, n + (100 - d) / 100 * h + s / 2 - a / 2),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"minText"), v - l - w, n + (100 - d) / 100 * h + s / 2 - a / 2 + 3),
        ctx.fillText(d, v - l - w, n + (100 - d) / 100 * h + s / 2 - a / 2 + b),
        ctx.moveTo(m, n + (100 - u) / 100 * h + s / 2 - a / 2),
        ctx.lineTo(m - l, n + (100 - u) / 100 * h + s / 2 - a / 2),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"maxText") , m - l, n + (100 - u) / 100 * h + s / 2 - a / 2 + 3),
        ctx.fillText(u, m - l, n + (100 - u) / 100 * h + s / 2 - a / 2 + b))) : (w = m - v,
        r >= o ? (ctx.moveTo(v, n + (100 - d) / 100 * h),
        ctx.lineTo(v - l, n + (100 - d) / 100 * h),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"minText"), v - l, n + (100 - d) / 100 * h + 3),
        ctx.fillText(d, v - l, n + (100 - d) / 100 * h + 15),
        ctx.moveTo(m, n + (100 - u) / 100 * h),
        ctx.lineTo(m - l - w, n + (100 - u) / 100 * h),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"maxText") , m - l - w, n + (100 - u) / 100 * h + 3),
        ctx.fillText(u, m - l - w, n + (100 - u) / 100 * h + 15)) : (ctx.moveTo(v, n + (100 - d) / 100 * h + s / 2 - a / 2),
        ctx.lineTo(v - l, n + (100 - d) / 100 * h + s / 2 - a / 2),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"minText"), v - l, n + (100 - d) / 100 * h + s / 2 - a / 2 + 3),
        ctx.fillText(d, v - l, n + (100 - d) / 100 * h + s / 2 - a / 2 + b),
        ctx.moveTo(m, n + (100 - u) / 100 * h + s / 2 - a / 2),
        ctx.lineTo(m - l - w, n + (100 - u) / 100 * h + s / 2 - a / 2),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"maxText") , m - l - w, n + (100 - u) / 100 * h + s / 2 - a / 2 + 3),
        ctx.fillText(u, m - l - w, n + (100 - u) / 100 * h + s / 2 - a / 2 + b))) : d && !u ? r >= o ? (ctx.moveTo(v, n + (100 - d) / 100 * h),
        ctx.lineTo(v - l, n + (100 - d) / 100 * h),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"minText"), v - l, n + (100 - d) / 100 * h + 3),
        ctx.fillText(d, v - l, n + (100 - d) / 100 * h + 15)) : (ctx.moveTo(v, n + (100 - d) / 100 * h + s / 2 - a / 2),
        ctx.lineTo(v - l, n + (100 - d) / 100 * h + s / 2 - a / 2),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"minText"), v - l, n + (100 - d) / 100 * h + s / 2 - a / 2 + 3),
        ctx.fillText(d, v - l, n + (100 - d) / 100 * h + s / 2 - a / 2 + b)) : u && !d && (r >= o ? (ctx.moveTo(m, n + (100 - u) / 100 * h),
        ctx.lineTo(m - l, n + (100 - u) / 100 * h),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"maxText") , m - l, n + (100 - u) / 100 * h + 3),
        ctx.fillText(u, m - l, n + (100 - u) / 100 * h + 15)) : (ctx.moveTo(m, n + (100 - u) / 100 * h + s / 2 - a / 2),
        ctx.lineTo(m - l, n + (100 - u) / 100 * h + s / 2 - a / 2),
        ctx.direction = "rtl",
        ctx.fillText(getDataValue(node.data,"maxText") , m - l, n + (100 - u) / 100 * h + s / 2 - a / 2 + 3),
        ctx.fillText(u, m - l, n + (100 - u) / 100 * h + s / 2 - a / 2 + b)));
        ctx.stroke(),
        ctx.closePath()
    }(ctx, node),
    function(ctx, node) {
        const i = node.rect.width > node.rect.height ? node.rect.height : node.rect.width
          , n = node.rect.width > node.rect.height ? node.rect.width : node.rect.height
          , r = Math.floor(i / 2)
          , o = 2;
        let s = node.rect.x
          , a = node.rect.y;
        const c = r - o / 2;
        let l, h;
        node.lineWidth = o,
        node.rect.width > node.rect.height ? (l = s + n / 2,
        h = a + r) : node.rect.width < node.rect.height ? (l = s + r,
        h = a + n / 2) : (l = s + r,
        h = a + r);
        ctx.beginPath(),
        ctx.moveTo(l + c, h),
        ctx.arc(l, h, c, 0, 2 * Math.PI),
        ctx.stroke(),
        ctx.closePath()
    }(ctx, node),
    !1
}

function getDataValue(data,key){
    var value="";
    for(var i=0;i<data.length;i++){
        if(data[i].name==key){
            value=data[i].value;
            break;
        }
    }
    return value;
}

/*export function register_watermeter() {
  (window).Le5leTopology.registerNode('watermeter', watermeter);
}*/